import request from '@/utils/request'

/**
 * 获取用户积分明细列表
 * @param {Object} params 查询参数
 * @param {String} params.link 关联手机号
 * @param {Number} params.page 页码
 * @param {Number} params.row 每页条数
 */
export function getIntegralDetailList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.listIntegralDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}